import { DocumentDuplicateIcon } from '@heroicons/react/24/solid'
import { useContext, useState } from 'react'
import { MessageContext } from './util/message-context'
import { cn } from '@/util/cn'

type Props = { text: string }
const CopyButton = ({ text }: Props) => {
    const [effect, setEffect] = useState(false)
    const { setMessages } = useContext(MessageContext)
    return (
        <DocumentDuplicateIcon
            className={cn(
                `menu-icon hover:stroke-accent`,
                effect && 'animate-wiggle',
                effect ? 'fill-accent' : 'stroke-primary'
            )}
            onClick={async (e) => {
                e.preventDefault()
                e.stopPropagation()
                setEffect(true)
                await navigator.clipboard.writeText(text)
                setMessages([{ text: 'Copied Text' }])
            }}
            onAnimationEnd={() => {
                setEffect(false)
            }}
        />
    )
}
export default CopyButton
